const buttons = document.querySelectorAll('.global-player-controls button');
const playSpans = document.querySelectorAll('.global-player-controls .play');
const pauseSpans = document.querySelectorAll('.global-player-controls .pause');
const videos = document.querySelectorAll('video');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

window.isPlaying = window.isPlaying || true;

if (videos.length && window.IntersectionObserver) {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  };

  videos.forEach((video) => {
    const obs = new IntersectionObserver(async (entries) => {
      const [{ isIntersecting }] = entries;
      if (!reducedMotion.matches && isIntersecting) {
        await video.play();
        return true;
      }
      if (window.isPlaying && !isIntersecting) {
        video.pause();
        return false;
      }
      return false;
    }, options);
    obs.observe(video);
  });

  const togglePlay = async () => {
    pauseSpans.forEach((pause) => pause.classList.toggle('u-hidden'));
    playSpans.forEach((play) => play.classList.toggle('u-hidden'));

    if (window.isPlaying) {
      videos.forEach((video) => video.pause());
      window.isPlaying = false;
      return false;
    }
    videos.forEach((video) => video.play());
    window.isPlaying = true;
    return true;
  };

  if (buttons.length) {
    buttons.forEach((btn) => {
      btn.addEventListener('click', togglePlay);
    });
  }
}
